import { render, staticRenderFns } from "./witness-details.vue?vue&type=template&id=e2b360f2&"
import script from "./witness-details.vue?vue&type=script&lang=js&"
export * from "./witness-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports